import { render, staticRenderFns } from "./PreparationJourney.vue?vue&type=template&id=2cb80988&scoped=true"
import script from "./PreparationJourney.vue?vue&type=script&lang=js"
export * from "./PreparationJourney.vue?vue&type=script&lang=js"
import style0 from "./PreparationJourney.vue?vue&type=style&index=0&id=2cb80988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb80988",
  null
  
)

export default component.exports